import { render, staticRenderFns } from "./BonusGoldModal.vue?vue&type=template&id=2c51d7e8&"
import script from "./BonusGoldModal.vue?vue&type=script&lang=js&"
export * from "./BonusGoldModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports